import React from 'react';
import './auth.css';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const Check = () => (
  <span className="ecd-auth__check" aria-hidden="true">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 6 9 17l-5-5"
        stroke="#fff"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

/**
 * Shared two-pane auth shell: tinted brand panel + form card.
 * To use a real background photo, set `--ecd-auth-bg` below to
 * `url('https://cdn.easychatdesk.com/...jpg')`.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ title, subtitle, children }) => {
  const brandStyle = {
    ['--ecd-auth-bg' as any]: "url('https://easychatdesk.com/images/support.jpg')"
  } as React.CSSProperties;

  return (
    <div className="ecd-auth">
      <div className="ecd-auth__brand" style={brandStyle}>
        <img
          className="ecd-auth__brand-logo"
          src="https://easychatdesk.com/images/white_logo.png"
          alt="EasyChatDesk"
        />
        <div>
          <h1 className="ecd-auth__brand-headline">Talk to your customers in real time.</h1>
          <p className="ecd-auth__brand-sub">
            Live chat, tickets and your whole support workflow — in one place.
          </p>
          <ul className="ecd-auth__features">
            <li>
              <Check /> Real-time chat with website visitors
            </li>
            <li>
              <Check /> Turn conversations into tickets
            </li>
            <li>
              <Check /> One lightweight widget, any website
            </li>
          </ul>
        </div>
        <div className="ecd-auth__brand-footer">
          © {new Date().getFullYear()} EasyChatDesk. All rights reserved.
        </div>
      </div>

      <div className="ecd-auth__main">
        <div className="ecd-auth__card">
          <img
            className="ecd-auth__logo-mobile"
            src="https://easychatdesk.com/images/easychatdesklogo.png"
            alt="EasyChatDesk"
          />
          <h2 className="ecd-auth__title">{title}</h2>
          {subtitle && <p className="ecd-auth__subtitle">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
